<template>
<div class="chapter">
<div class="inner_page">
<p class="Basic-Paragraph para-style-override-7">Copyright © 2016</p>
<p class="Basic-Paragraph para-style-override-7">By T. J. Ray</p>
<p class="Basic-Paragraph para-style-override-7">All rights reserved</p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-8"><span class="char-style-override-4">The word “Pelican” and the depiction of a pelican are</span></p>
<p class="Basic-Paragraph para-style-override-8"><span class="char-style-override-4">trademarks of Pelican Publishing Company, Inc., and are</span></p>
<p class="Basic-Paragraph para-style-override-8"><span class="char-style-override-4">registered in the U.S. Patent and Trademark Office.</span></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-9">Library of Congress Cataloging-in-Publication Data</p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7">Ray, T. J., author.</p>
<p class="Basic-Paragraph para-style-override-7">Side by side : moonshine and murder in Mississippi / by T.J. Ray.</p>
<p class="Basic-Paragraph para-style-override-7">pages cm</p>
<p class="Basic-Paragraph para-style-override-7">Includes bibliographical references and index.</p>
<p class="Basic-Paragraph para-style-override-7">ISBN 978-1-4556-2183-5 (pbk. : alk. paper) — ISBN 978-1-4556-2184-2 (e-book) 1. Mathis, Will, -1902. 2. Murder—Mississippi—Oxford—Case studies. 3. Oxford (Miss.)—History—20th century. I. Title.</p>
<p class="Basic-Paragraph para-style-override-7">HV6534.O94R39 2016</p>
<p class="Basic-Paragraph para-style-override-7">364.152’3092276283--dc23</p>
<p class="Basic-Paragraph para-style-override-7">2015030524</p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-7"></p>
<p class="Basic-Paragraph para-style-override-10">Printed in the United States of America</p>
<div class="frame-2"><img alt="40948.jpg" class="frame-4" src="Images/40948.jpg"/></div>
<p class="Basic-Paragraph para-style-override-7">Published by Pelican Publishing Company, Inc.</p>
<p class="Basic-Paragraph para-style-override-11"><span class="char-style-override-5">1000 Burmaster Street, Gretna, Louisiana 70053</span></p>
<p class="Basic-Paragraph para-style-override-8"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?0b4693ac